import { useMutation } from "@tanstack/react-query";

import { getVerifyCode } from "@/shared/requests/auth";
import type { LoginMethod } from "@/shared/requests/auth.type";

export function useGetVerifyCode() {
  const mutationFn = async ({
    phone,
    loginMethod,
  }: {
    phone: string;
    loginMethod?: LoginMethod;
  }) => {
    return getVerifyCode({ phone, loginMethod });
  };
  return useMutation(mutationFn);
}
